import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const MinimizeIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 14.7)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m.75 11.25h5v5" />
      <path d="m16.25 5.75h-5v-5" />
    </SVG>
  );
};
